import { sentryCaptureException } from "@/lib/sentry";
import axios from "axios";

const apiServer = axios.create({
  baseURL: "https://gnbapi.nexon.com",
  timeout: 10000,
  withCredentials: false,
});

export const checkCafe = async () => {
  try {
    const response = await apiServer.get<{ hasError: boolean; isAtPcBang: boolean }>("/myinfo/pcbang-check");

    return response.data;
  } catch (error) {
    sentryCaptureException(error, {
      tags: { api: "checkCafe" },
    });
    throw error;
  }
};
